/* @ngInject */
function SidebarCompanySelectController ($rootScope, $scope, $state, $timeout, $q, UserService, ModalService, Utils, CONSTANTS, CompanyService) {
  const getChangeCompanyDialogController = () => $q.when(import('../../dialogs/change-company/change-company-dialog.controller'))

  $scope.companies = []
  $scope.showMoreBtn = null
  $scope.showDropdown = false
  $scope.currentCompanyId = null
  $scope.params = {
    search: '',
    sort: false,
    active: true
  }

  const api = {
    _successGetCompanies,
    _handleSuccessUpdateCompany,
    getChangeCompanyDialogController
  }
  this.getApi = () => api

  activate()

  function activate () {
    $rootScope.getUserCompany().then((res) => {
      $scope.currentCompanyId = res.id
    })
    UserService.getUserCompanies(5, 0, $scope.params).then(api._successGetCompanies)
  }

  function _successGetCompanies (res) {
    $scope.companies = res.companies
    $scope.showMoreBtn = res.count > 5
  }

  $scope.toggleDropdown = () => {
    $timeout(() => {
      $scope.showDropdown = !$scope.showDropdown
    }, 0, true)
  }

  $scope.openChangeCompanyDialog = function () {
    api.getChangeCompanyDialogController().then(({ ChangeCompanyDialogController }) => {
      ModalService.showModal({
        templateId: 'changeCompany.html',
        templateUrl: '/core/dialogs/change-company/change-company-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        controller: ChangeCompanyDialogController
      })
    })
  }

  $scope.getLogoUrl = function (customerCompanyId) {
    return Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_COMPANY_LOGO_COLORED, [customerCompanyId])
  }

  $scope.changeUserCompany = function (customerCompanyId) {
    UserService.updateUserCompany(customerCompanyId).then(api._handleSuccessUpdateCompany)
  }

  function _handleSuccessUpdateCompany () {
    CompanyService.reloadWithNewCompany()
  }

  $scope.getDropdownIcon = function () {
    if ($scope.mobile) return 'chevron-up'
    return 'chevron-down'
  }
}

export { SidebarCompanySelectController }
